import { Component, EventEmitter, Input, Output, input } from "@angular/core";

export interface Will4HelpSectionItem {
	imageSrc: string;
	imageAlt: string;
	title: string;
	paragraphs: string[];
}

export interface Will4HelpSectionCta {
	title: string;
	url: string;
}

@Component({
	selector: "app-will4-help-section",
	templateUrl: "./will4-help-section.component.html",
	styleUrls: ["./will4-help-section.component.scss"],
})
export class Will4HelpSectionComponent {
	@Input() title = "";
	items = input<Will4HelpSectionItem[]>([]);
	@Input() cta: Will4HelpSectionCta | null = null;
	@Output() ctaClick = new EventEmitter<Will4HelpSectionCta>();

	onCtaClick(): void {
		if (!this.cta) {
			return;
		}

		this.ctaClick.emit(this.cta);
	}
}
